import { Platform, StyleSheet } from 'react-native';

import { mediaQueryValues } from '../media-query';
import {
  smallPaddingHorizontalBox,
  extraSmallPaddingVerticalBox,
  dashedBorderBox,
  roundedBox,
} from '../view-style';

const mediaQuery = mediaQueryValues();

export default StyleSheet.create({
  view: {
    ...dashedBorderBox,
    ...roundedBox,
  },
  text: {
    ...smallPaddingHorizontalBox,
    ...extraSmallPaddingVerticalBox,
    fontSize: mediaQuery.small,
    ...Platform.select({ web: { outlineWidth: 0 } }),
  },
});
